import { useTranslation } from 'react-i18next';
import { PLATFORM_THEME_COLORS, Table, Typography } from '@thinknet-gmbh/platform-common-ui';

import SalaryTypesTableRowActions from './salary-types-table-row-actions.component';

import { ISalaryTypesTableProps } from './salary-types-table.interfaces';

const SalaryTypesTable = ({
  dataSource,
  paginationConfig,
  handleModals,
  onTableChange,
  loading,
}: ISalaryTypesTableProps) => {
  const { t } = useTranslation(['common', 'settings']);

  return (
    <Table
      loading={loading}
      dataSource={dataSource}
      pagination={paginationConfig}
      rowKey={record => record._id}
      t={t}
    >
      <Table.Column
        width={100}
        title={t('settings:salaryTypes.labels.number')}
        sorter={onTableChange}
        render={({ salaryTypeNumber }) => <Typography>{salaryTypeNumber}</Typography>}
      />
      <Table.Column
        title={t('settings:salaryTypes.labels.name')}
        sorter={onTableChange}
        render={({ name }) => <Typography>{name}</Typography>}
      />

      <Table.Column
        title={t('settings:salaryTypes.labels.clients')}
        render={({ clients = [] }) => {
          const numberString = clients
            .map(({ datevNumber }: { datevNumber: string }) => {
              return datevNumber;
            })
            .join(', ');

          return (
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>{numberString}</Typography>
          );
        }}
      />
      <Table.Column
        width={50}
        title={t('common:labels.action')}
        render={record => (
          <SalaryTypesTableRowActions record={record} handleModals={handleModals} t={t} />
        )}
      />
    </Table>
  );
};

export default SalaryTypesTable;
